var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCvv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0312 10.7389C11.0312 8.14136 13.146 6.02876 15.7464 6.02876C18.3469 6.02876 20.4617 8.14136 20.4617 10.7389V13.081H11.0312V10.7389ZM23.9981 13.081H22.8193V10.7389C22.8193 6.8432 19.6471 3.67371 15.7465 3.67371C11.8458 3.67371 8.67359 6.8432 8.67359 10.7389V13.081H7.49478C6.51872 13.081 5.72656 13.8719 5.72656 14.8476V26.6229C5.72656 27.5985 6.51872 28.3894 7.49478 28.3894H23.9981C24.9742 28.3894 25.7663 27.5985 25.7663 26.6229V14.8476C25.7663 13.8719 24.9742 13.081 23.9981 13.081ZM16.9253 20.9971V23.6793C16.9253 24.329 16.3972 24.8563 15.7464 24.8563C15.0946 24.8563 14.5676 24.329 14.5676 23.6793V20.9971C13.8651 20.5899 13.3888 19.839 13.3888 18.9692C13.3888 17.6687 14.4439 16.6142 15.7464 16.6142C17.0479 16.6142 18.1041 17.6687 18.1041 18.9692C18.1041 19.839 17.6267 20.5899 16.9253 20.9971Z",
    fill: "#6C6C6C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvv);
export default __webpack_public_path__ + "static/media/cvv.c2fb0d5956b18e1bb70fdd0929f6f271.svg";
export { ForwardRef as ReactComponent };